<template>
  <div v-wechat-title="$route.meta.title">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner title="xnyqc" :locale="locale"></common-banner>
    <!-- 应用领域 -->
    <u-animate-container class="application_areas">
      <common-title :cn="$t('xnyqc.title')"></common-title>
      <div class="item_left">
        <img src="@/assets/images/solution_png1.jpg" class="bg" />
        <img src="@/assets/images/solution_pro1.png" class="pro1" />
        <div class="desc">
          <p>{{ $t("solution.p1") }}</p>
          <p>{{ $t("solution.p2") }}</p>
          <div class="title">灯笼铆钉<span>TRI-LUK RIVETS</span></div>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="item_right">
        <img src="@/assets/images/solution_png2.jpg" class="bg" />
        <img src="@/assets/images/solution_pro2.png" class="pro2" />
        <div class="desc">
          <p>{{ $t("solution.p1") }}</p>
          <div class="title">灯笼铆钉<span>TRI-LUK RIVETS</span></div>
        </div>
        <div style="clear:both"></div>
      </div>
    </u-animate-container>
    <!-- 实际应用 -->
    <u-animate-container class="practical_application">
      <common-title :cn="$t('txt.sjyy')"></common-title>
      <div class="wrap">
        <img src="@/assets/images/solution_b_pro.png" class="top" />
        <div class="list" v-if="list && list.length != 0">
          <template v-for="(item, index) in list">
            <div
              class="item"
              v-if="index <= 4"
              :key="item['number'] + item['featureDesc']"
            >
              <div class="img_wrap">
                <img :src="item['spapImage']" />
                <div class="num">{{ item["number"] }}</div>
                <div class="txt">{{ item["featureDesc"] }}</div>
              </div>
              <div class="content_wrap">
                <img :src="item['pHorizontalImage']" />
                <router-link
                  :to="
                    '/pd/' +
                      item['productId'] +
                      '/' +
                      encodeURI(item.pName.replace('/', ''))
                  "
                  class="cw_title_cn"
                  tag="div"
                  >{{ item["pName"] }}</router-link
                >
                <router-link
                  :to="
                    '/pd/' +
                      item['productId'] +
                      '/' +
                      encodeURI(item.pName.replace('/', ''))
                  "
                  class="cw_title_en"
                  tag="div"
                  >{{ item["pEnglishName"] }}</router-link
                >
                <div class="cw_content">{{ item["productDesc"] }}</div>
              </div>
            </div>
          </template>
          <!-- <div class="item" v-for="(item,index) in list" :key="item['number'] + item['featureDesc']" v-if="index<=4">
            <div class="img_wrap">
              <img :src="item['spapImage']">
              <div class="num">{{item['number']}}</div>
              <div class="txt">{{item['featureDesc']}}</div>
            </div>
            <div class="content_wrap">
              <img :src="item['pHorizontalImage']">
              <router-link :to="'/product/'+ item['productId']" class="cw_title_cn" tag="div">{{item['pName']}}</router-link>
              <router-link :to="'/product/'+ item['productId']" class="cw_title_en" tag="div">{{item['pEnglishName']}}</router-link>
              <div class="cw_content">{{item['productDesc']}}</div>
            </div>
          </div> -->
        </div>
        <!-- <div class="btn_view_product" @click="view_product">查看产品</div> -->
      </div>
    </u-animate-container>
    <common-footer :locale="locale"></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
import CommonTitle from "./components/Common/Title";
export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonHeader,
    CommonNav,
    CommonFooter,
    CommonBanner,
    CommonTitle
  },
  created() {
    let _router = this.$route;
    this.id = parseInt(
      _router.path.split("/")[_router.path.split("/").length - 1]
    );
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    this.getData(this.id, this.locale);
  },
  watch: {
    locale(a, b) {
      console.log("locale变化（indexproduct）", a, b);
      this.getData(this.id, this.locale);
    }
  },
  data() {
    return {
      list: [],
      locale: "zh-cn"
    };
  },
  methods: {
    getLocale(e) {
      this.locale = e;
    },
    view_product() {
      console.log("查看产品");
    },
    getData(id, lang) {
      console.log(id);
      let lang2 = lang ? lang : "zh-cn";
      this.$axios
        .post(
          "/api/solution/index",
          {
            category: id
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.list = res.data.data.item;
            this.$route.meta.title = res.data.data.categoryName + " - 解决方案";
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.application_areas {
  padding: 60px 0;
  background: #fff;
  box-sizing: border-box;
  .item_left {
    width: 100%;
    position: relative;
    img.bg {
      width: 60%;
      height: auto;
      float: left;
    }
    img.pro1 {
      position: absolute;
      width: 15%;
      height: auto;
      left: 70%;
      top: 0;
      z-index: 9;
    }
    .desc {
      position: absolute;
      bottom: 0;
      left: 50%;
      background: #fff;
      display: flex;
      display: -ms-flexbox;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 0.2rem;
      line-height: 2;
      color: #333;
      padding: 1.5rem 0.5rem;
      box-sizing: border-box;
      width: 16%;
      .title {
        position: absolute;
        background: #fd8204;
        color: #fff;
        font-size: 0.25rem;
        text-align: center;
        padding: 0.05rem 0.5rem;
        width: 3rem;
        top: 0.3rem;
        left: -1rem;
        span {
          font-size: 0.15rem;
          margin-left: 0.1rem;
        }
      }
    }
  }
  .item_right {
    width: 100%;
    position: relative;
    img.bg {
      width: 60%;
      height: auto;
      float: right;
    }
    img.pro2 {
      position: absolute;
      width: 15%;
      height: auto;
      right: 70%;
      top: 5%;
      z-index: 9;
    }
    .desc {
      position: absolute;
      top: 0;
      right: 50%;
      background: #fff;
      display: flex;
      display: -ms-flexbox;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      line-height: 2;
      color: #333;
      padding: 1.5rem 0.5rem;
      box-sizing: border-box;
      width: 16%;
      .title {
        position: absolute;
        background: #fd8204;
        color: #fff;
        font-size: 0.25rem;
        text-align: center;
        padding: 0.05rem 0.5rem;
        width: 3rem;
        bottom: 0.3rem;
        left: 0rem;
        span {
          font-size: 0.15rem;
          margin-left: 0.1rem;
        }
      }
    }
  }
}
.practical_application {
  padding: 90px 0;
  img.top {
    width: 60%;
    margin: 0 auto;
    display: block;
  }
  .list {
    display: flex;
    display: -ms-flexbox;
    -ms-flex-direction: row;
    flex-direction: row;
    width: 1140px;
    height: auto;
    // overflow: hidden;
    margin: 0rem auto;
    position: relative;

    justify-content: center;
    .item {
      width: 23%;
      display: flex;
      display: -ms-flexbox;
      height: auto;
      flex-direction: column;
      -ms-flex-direction: column;
      // overflow: hidden;
      .img_wrap {
        width: 100%;
        height: 270px;
        box-sizing: border-box;
        // background: url("../assets/images/border_img_solution.png") no-repeat
        //   center center;
        background-size: 100% 100%;
        color: #f2f0ee;
        position: relative;
        display: flex;
        display: -ms-flexbox;
        justify-content: center;
        align-items: center;
        padding: 15px;
        img {
          width: 100%;
          height: 100%;
          display: flex;
          display: -ms-flexbox;
        }
        .num {
          border: 1px solid #f2f0ee;
          width: 40px;
          height: 40px;
          line-height: 40px;
          border-radius: 50%;
          text-align: center;
          position: absolute;
          top: 33%;
          font-size: 0.3rem;
        }
        .txt {
          position: absolute;
          top: 42%;
          font-size: 0.2rem;
        }
      }
      .content_wrap {
        width: 90%;
        min-height: 300px;
        height: auto;
        background: #f7f7f7;
        background-size: 100% 100%;
        margin-top: 20px;
        font-size: 0.25rem;
        box-sizing: border-box;
        margin-left: 5%;
        padding: 0.3rem 0.3rem 0.3rem 0.3rem;
        position: relative;
        img {
          position: absolute;
          width: 0.35rem;
          height: 1.8rem;
          left: -0.2rem;
          top: 0.2rem;
        }
        .cw_title_cn {
          color: #ff8300;
          font-size: 0.18rem;
          cursor: pointer;
        }
        .cw_title_en {
          margin-top: 0.05rem;
          color: #696969;
          font-size: 0.13rem;
          cursor: pointer;
        }
        .cw_content {
          color: #333;
          font-size: 0.13rem;
          line-height: 1.8;
        }
      }
    }
  }
  .btn_view_product {
    border: 4px solid #ff7f00;
    color: #ff7f00;
    background: none;
    font-size: 0.25rem;
    width: 2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    border-radius: 0.8rem;
    text-align: center;
    margin: 0px auto 30px;
    text-decoration: none;
  }
}
@media screen and (max-width: 750px) {
  .application_areas {
    padding: 15px 0;
    .item_left {
      margin-bottom: 1.5rem;
      display: flex;
      flex-direction: column-reverse;
      img.bg {
        width: 100%;
        height: 250px;
      }
      img.pro1 {
        display: none;
      }
      .desc {
        position: relative;
        left: 0;
        width: 100%;
        padding: 0 30px;
        font-size: 0.5rem;
        height: auto;
        border-radius: 6px;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        flex-direction: column-reverse;
        align-items: flex-start;
        box-sizing: border-box;
        p {
          font-size: 0.8rem;
          &:nth-of-type(2) {
            order: 1;
            margin-bottom: 0.5rem;
          }
          &:first-child {
            order: 2;
          }
        }
        .title {
          order: 3;
          font-size: 1.5rem;
          width: 100%;
          text-align: center;
          position: relative;
          margin: auto;
          border-radius: 4px;
          background: #fd8204;
          top: 0;
          left: 0;
          height: 3.5rem;
          line-height: 3.5rem;
          box-sizing: border-box;
          span {
            position: relative;
            top: 0.1rem;
            left: 0.2rem;
          }
        }
      }
    }
    .item_right {
      margin-top: 1.5rem;
      display: flex;
      flex-direction: column-reverse;
      img.bg {
        width: 100%;
        height: 250px;
      }
      img.pro2 {
        display: none;
      }
      .desc {
        position: relative;
        left: 0;
        width: 100%;
        padding: 0 30px;
        font-size: 0.5rem;
        height: auto;
        border-radius: 6px;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        flex-direction: column-reverse;
        align-items: flex-start;
        box-sizing: border-box;
        p {
          font-size: 0.8rem;
          &:nth-of-type(2) {
            order: 1;
            margin-bottom: 0.5rem;
          }
          &:first-child {
            order: 2;
          }
        }
        .title {
          order: 3;
          font-size: 1.5rem;
          width: 100%;
          text-align: center;
          position: relative;
          margin: auto;
          border-radius: 4px;
          background: #fd8204;
          top: 0;
          left: 0;
          height: 3.5rem;
          line-height: 3.5rem;
          box-sizing: border-box;
          span {
            position: relative;
            top: 0.1rem;
            left: 0.2rem;
          }
        }
      }
    }
  }
  .practical_application {
    padding: 15px 0;
    .list {
      width: 100%;
      box-sizing: border-box;
      padding: 0 60px;
      flex-wrap: wrap;
      .item {
        width: 100%;
        margin-bottom: 0.8rem;
        .img_wrap {
          height: 200px;
          .num {
            width: 1.5rem;
            height: 1.5rem;
            line-height: 1.5rem;
            font-size: 0.8rem;
          }
          .txt {
            top: 56%;
            font-size: 0.5rem;
          }
        }
        .content_wrap {
          margin-top: 0;
          font-size: 0.8rem;
          padding: 0.3rem 0.8rem 0.8rem 0.8rem;
          height: auto;
          min-height: auto;
          width: 100%;
          margin-left: 0;
          background: #fff;
          img {
            display: none;
          }
          .cw_title_cn {
            font-size: 0.8rem;
            text-align: center;
          }
          .cw_title_en {
            margin-top: 0.3rem;
            text-align: center;
          }
          .cw_content {
            margin-top: 0.5rem;
            font-size: 0.6rem;
          }
        }
      }
    }
    .btn_view_product {
      font-size: 0.8rem;
      height: 2rem;
      line-height: 2rem;
      width: 7rem;
      border-width: 0.1rem;
      margin: 1rem auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/xnyqc.vue